// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsCancelRefillResponse

export type SmsCancelRefillApiResponse = {
	canceled: boolean;
};

export type SmsCancelRefill = {
	canceled: boolean;
};

export function hydrateSmsCancelRefill(data: SmsCancelRefillApiResponse): SmsCancelRefill {
	return { ...data };
}